import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition
} from '@evinced-private/ui-common';

import { FilterTypesNames } from 'src/common/consts/app_consts';

const searchFilter: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {}
};

export const mobileSdkTestsFilterDefinitions: IFilterDefinition[] = [
	searchFilter,
	{
		id: FilterTypesNames.LABELS,
		label: 'labels',
		filterType: 'select',
		defaultValue: [],
		width: '140px',
		componentProps: {
			placeholder: 'Select Label',
			allSelectedPlaceholder: 'All Labels',
			someItemsSelectedText: (numberOfItems: number) => `Labels (${numberOfItems})`,
			isMultiple: true,
			id: FilterTypesNames.LABELS,
			label: 'Label'
		}
	} as ISelectFilterDefinition
];
